import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import {
  CmsConfig,
  I18nModule,
  provideDefaultConfig,
  UrlModule,
  ConfigModule,
  provideConfig,
} from '@spartacus/core'
import { LoginComponent } from './login.component'
import { MatMenuModule } from '@angular/material/menu'
import { MatIconModule } from '@angular/material/icon'
import { MatCardModule } from '@angular/material/card'
import {
  PageSlotModule,
  MediaModule,
  SpinnerModule,
} from '@spartacus/storefront'
import { PlpMenuBarComponent } from '../../plp/plp-menu-bar/plp-menu-bar.component'
import { ChangeCustAccountModule } from '../change-cust-account/change-cust-account.module'
import { CustomerAccountModule } from '../customer-account/customer-account.module'
import { NgSelectModule } from '@ng-select/ng-select'
import { FormsModule } from '@angular/forms'
import { ClickOutsideModule } from '../../../shared/directive/clickOutside/click-outside.module'
import { environment } from '../../../../environments/environment'
import { NavBarLinksComponent } from '../../nav-bar-links/nav-bar-links.component'

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    I18nModule,
    MatMenuModule,
    PageSlotModule,
    MediaModule,
    MatIconModule,
    MatCardModule,
    NgSelectModule,
    FormsModule,
    ClickOutsideModule,
    SpinnerModule,
    ChangeCustAccountModule,
    CustomerAccountModule,
    I18nModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + 'assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['login'],
        },
      },
    }),
  ],
  providers: [
    provideConfig({
      cmsComponents: {
        LoginComponent: {
          component: LoginComponent,
        },
      },
    } as CmsConfig),
  ],
  declarations: [LoginComponent, NavBarLinksComponent, PlpMenuBarComponent],
  exports: [LoginComponent],
})
export class LoginModule {}
